module.exports = __webpack_public_path__ + "static/scale-model-of-heritage-farmstead-museum-in-plano-texas-63e13a6d6b899e77ac309d7c6c7b866a.png";